$(document).on('turbolinks:load', function() {
    let domains_datatable = $('#domains_datatable').DataTable({
        "processing": true,
        "serverSide": true,
        "scrollX": true,
        "ajax": {
            "url": $('#domains_datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
            {"data": "company", visible: $('#current_user_is_super_admin').val() == 'true'},
            {"data": "name"},
            {"data": "description"}
        ]
    });


    $('#domains_datatable').on( 'click', 'tbody tr', function () {
        let id = domains_datatable.row( this ).id();

        if (id != undefined) {
            window.location = '/domains/'+id;
        }
    });
});